import React from 'react';
import cx from 'classnames';
import './styles.scss';
const Screen = ({ screenClass, children, onScroll }) => {
	return <div className={cx('main-screen animated fadeIn pd-h-20', screenClass)}>{children}</div>;
};
export default Screen;
